import React, { useContext } from "react";
import { TestContext } from "../../context/test_context";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import TestActionButtons from "./TestActionButtons";

export default function TestButtonSet({ testgroup, setTestGroup }: any) {
  const { deleteTestGroup, pauseTestGroup, restartTestGroup, stopTestGroup } =
    useContext(TestContext);
  const navigate = useNavigate();

  if (!testgroup) return <div className="h-6" />;

  const handlePlayPause = async () => {
    const resp = await pauseTestGroup(testgroup.id);
    if (resp.success) setTestGroup(resp.testgroup);
  };

  const handleStop = async () => {
    const resp = await stopTestGroup(testgroup.id);
    if (resp.success) setTestGroup(resp.testgroup);
  };

  const handleRestart = async () => {
    const resp = await restartTestGroup(testgroup.id);
    if (resp.success) setTestGroup(resp.testgroup);
  };

  const handleDelete = async () => {
    const resp = await deleteTestGroup(testgroup.id);
    if (resp.success) {
      navigate(testgroup.finished ? "/finished" : "/tests");
    } else {
      toast.error("Delete failed. Please try again.");
    }
  };

  return (
    <TestActionButtons
      testgroup={testgroup}
      onTogglePlayPause={handlePlayPause}
      onStop={handleStop}
      onRestart={handleRestart}
      onDelete={handleDelete}
    />
  );
}
